var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Toasters"},_vm._l((_vm.toastersData),function(toaster){return _c('toaster',{key:toaster.id,attrs:{"id":toaster.id,"message":toaster.message,"icon":toaster.icon},on:{"remove":_vm.removeToaster}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }